import axios from "axios";
import { setupAxiosInterceptors } from "./setupInterceptors";
import API_URL from "../utils/API_URL";

const BASE_URL = "https://dev.insightwin.com/backend";

// const BASE_URL = API_URL;

// 일반 Axios 인스턴스
export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

// 보호된 API Axios 인스턴스
export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

export const clearInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.request.handlers = [];
  axiosInstance.interceptors.response.handlers = [];
};

export const initializeInterceptors = (refresh) => {
  clearInterceptors(axiosPrivate);
  setupAxiosInterceptors(axiosPrivate, refresh);
};
